export default __webpack_public_path__ + "static/media/icon_carbohydrates.c23689a7.svg";